export class ApiError extends Error {
  status: number

  constructor(status: number, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

// fastify's default error body shape
type FastifyErrorBody = {
  statusCode?: number
  error?: string
  message?: string
}

async function handleResponse<T>(res: Response): Promise<T> {
  if (!res.ok) {
    let message = res.statusText || 'Request failed'
    try {
      const body = (await res.json()) as FastifyErrorBody
      if (body.message) message = body.message
    } catch {
      // non-json error body, keep the status text
    }
    throw new ApiError(res.status, message)
  }

  return res.json() as Promise<T>
}

export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<T> {
  let res: Response
  try {
    res = await fetch('/api' + path, { signal })
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') throw err
    throw new ApiError(0, 'Network error — could not reach the server')
  }

  return handleResponse<T>(res)
}

export async function apiPost<T>(path: string, body: unknown, signal?: AbortSignal): Promise<T> {
  let res: Response
  try {
    res = await fetch('/api' + path, {
      method: 'POST',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(body),
      signal,
    })
  } catch (err) {
    if (err instanceof DOMException && err.name === 'AbortError') throw err
    throw new ApiError(0, 'Network error — could not reach the server')
  }

  return handleResponse<T>(res)
}
